export default {
  sum: (total, x) => {
    return parseFloat(total) + parseFloat(x)
  },
  groupBy: (array, key, defaultCategory = null) => {
    const result = []
    array.forEach((item) => {
      let itemKey = item[key]
      itemKey = itemKey ? itemKey : defaultCategory || 'none'
      if (!result[itemKey]) {
        result[itemKey] = []
      }
      result[itemKey].push(item)
    })

    return result
  },
  sortAlphabetically(array, key = null) {
    return array.sort((a, b) => (key ? a[key] : a).localeCompare(key ? b[key] : b))
  },
}
